// The type styles /home shares, one per job. The page had grown 35 distinct
// text styles, with section headings in three looks and in-card labels in
// five, so each section is now built from these rather than its own numbers.

// Every section on the page: Your Leagues, Daily Games, Weekly Game, the
// week's scores, CFB News.
export const SECTION_HEADING = {
  fontSize: 18, fontWeight: 800, color: "var(--color-text-strong)", margin: 0,
  display: "flex", alignItems: "center", gap: 4,
};

// A label inside a card: Your lineup, Standings, Manager of the Week, a
// table's column heads.
export const CARD_LABEL = {
  fontSize: 11, fontWeight: 800, color: "var(--color-text-muted)",
  textTransform: "uppercase", letterSpacing: "0.06em",
};

// Text in a card's rows (team and manager names, headlines, scores), and the
// grey line under or beside it (kickoff, manager, source). Every card on the
// page uses these two, so no card reads a size up from its neighbours.
export const ROW_SIZE = 13;
export const META_SIZE = 12;

// Nothing on the page is set smaller than this.
export const MIN_TEXT = 9;
